export function showPopup(message, title = '', callback) {
  alert(title + '\n' + message);
  console.log(message);
  callback()
}
